import { useTranslation } from 'react-i18next';

import { InfoSection, InfoSectionWrapper, StyledTitle } from 'components/containers/InfoSection';

export const PageNotFound = () => {
  const { t } = useTranslation('error');
  return (
    <InfoSectionWrapper>
      <InfoSection onSuccess={false} />
      <StyledTitle>{t('no-page.not-found')}</StyledTitle>
    </InfoSectionWrapper>
  );
};
